import React from 'react';
import { Modal } from 'react-bootstrap';

const UpdateDentalServiceDetails = ({ editHairServiceModal, setEditHairServiceModal, hairServiceDetailsFormData, handleSubmitUpdateHairServiceDetails, handleChangeHairServiceFormData }) => {
    return (
        <>
            <Modal
                centered
                show={editHairServiceModal}
                onHide={() => setEditHairServiceModal(false)}
                size={"lg"}
            >
                <div className="modal-header">
                    <h3 className="modal-title" id="exampleModalLabel">Update Hair Service Details</h3>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setEditHairServiceModal(false)}
                    ></button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmitUpdateHairServiceDetails}>
                        <div className="row">
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="serviceDetailName" className="col-form-label">
                                        Name:
                                    </label>
                                    <input
                                        name="serviceDetailName"
                                        value={hairServiceDetailsFormData?.serviceDetailName}
                                        onChange={(e) => handleChangeHairServiceFormData(e)}
                                        type="text"
                                        className="form-control"
                                        placeholder="Hair Service Name"
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="pt_price" className="col-form-label">
                                        Patient Price:
                                    </label>
                                    <input
                                        type="text"
                                        name="pt_price"
                                        value={hairServiceDetailsFormData.pt_price}
                                        onChange={(e) => handleChangeHairServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Patient Price"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="client_price" className="col-form-label">
                                        Client Price:
                                    </label>
                                    <input
                                        type="text"
                                        name="client_price"
                                        value={hairServiceDetailsFormData.client_price}
                                        onChange={(e) => handleChangeHairServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Client Price"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="tax" className="col-form-label">
                                        Tax:
                                    </label>
                                    <input
                                        type="text"
                                        name="tax"
                                        value={hairServiceDetailsFormData.tax}
                                        onChange={(e) => handleChangeHairServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Tax"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="status" className="col-form-label">
                                        Status:
                                    </label>
                                    <div className='d-flex align-items-center gap-4'>
                                        {["Active", "Inactive", "Deleted"].map((status) => (
                                            <div className="form-check me-3" key={status}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="status"
                                                    id={status.toLowerCase()}
                                                    value={status}
                                                    checked={hairServiceDetailsFormData.status === status}
                                                    onChange={(e) => handleChangeHairServiceFormData(e)}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={status.toLowerCase()}
                                                >
                                                    {status}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setEditHairServiceModal(false)}
                            >
                                Close
                            </button>
                            <button type="submit" className="btn btn-success">Update</button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
};

export default UpdateDentalServiceDetails;